function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m462 386c5.519531 0 10-4.480469 10-10s-4.480469-10-10-10-10 4.480469-10 10 4.480469 10 10 10zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m30 512h452c16.542969 0 30-13.457031 30-30v-372c0-5.523438-4.476562-10-10-10h-70c0-55.140625-44.859375-100-100-100-55.257812 0-100 44.699219-100 100h-76c-5.523438 0-10 4.476562-10 10v116h-136c-5.523438 0-10 4.476562-10 10v246c0 16.542969 13.457031 30 30 30zm-10-30v-36h232v36c0 5.515625-4.484375 10-10 10h-212c-5.515625 0-10-4.484375-10-10zm462 10h-211.71875c1.109375-3.128906 1.71875-6.492188 1.71875-10v-36h220v36c0 5.515625-4.484375 10-10 10zm-150-472c44.113281 0 80 35.886719 80 80h-160c0-44.210938 35.761719-80 80-80zm-166 100h66v46h-10c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-10v-46h160v46h-10c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-10v-46h60v306h-220v-190c0-5.523438-4.476562-10-10-10h-96zm86 126v180h-232v-180zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m76 306v20c0 33.148438 26.851562 60 60 60 33.085938 0 60-26.914062 60-60v-20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-20c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10v20c0 22.054688-17.945312 40-40 40-22.09375 0-40-17.90625-40-40v-20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-20c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m462 346c5.523438 0 10-4.476562 10-10v-80c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v80c0 5.523438 4.476562 10 10 10zm0 0"
});

var SvgSale = function SvgSale(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sale.83e031c9.svg";
export { ForwardRef as ReactComponent };